:host{display:block;padding:0 3.7rem}:host:first-child{padding-left:0}:host:not(:last-child){border-right:1px solid #2E7FA1}.label{margin-bottom:1rem;font-size:1.1em;display:block;height:2rem;white-space:nowrap}
/*# sourceMappingURL=tool-setting.component-I4IYY6SD.css.map */
